import { api } from './api'
import type { Charger, ChargerSetup } from 'cleverev-types'


class ChargerAPI {

  public async listChargers(organizationId: string, listOptions?: {
    pagination?: { take?: number; skip?: number }
    chargerListSelector?: {
      id?: string | { in?: string[]; notIn?: string[]; search?: string }
      name?: string | { in?: string[]; notIn?: string[]; search?: string }
      chargePointSerialNumber?: string | { in?: string[]; notIn?: string[]; search?: string }
      namespaceId?: string | { in?: string[]; notIn?: string[] }
      locationId?: string | { in?: string[]; notIn?: string[] }
      applicationId?: string | { in?: string[]; notIn?: string[] }
    }
  }) {
    const result = await api.post<{ chargers: Charger[]; totalCount: number }>(
      '/chargers/list',
      { organizationId, ...listOptions }
    )

    return result.data
  }

  public async listChargerSetups(organizationId: string) {
    const result = await api.get<{ chargerSetups: ChargerSetup[]; totalCount: number }>(`/organizations/${organizationId}/charger-setups?take=9999`) // TODO: implement pagination

    return result.data
  }

  public async get(serialNumber: string) {
    const result = await api.get<{ chargerSetup: ChargerSetup }>(`/charger-setups/${serialNumber}`)

    return result.data.chargerSetup
  }

  public async update(serialNumber: string, partialCharger: Partial<ChargerSetup>) {
    const result = await api.post<{ chargerSetup: ChargerSetup }>(
      `/charger-setups/${serialNumber}`,
      partialCharger
    )

    return result.data.chargerSetup
  }

  public async create(newCharger: Partial<ChargerSetup>) {
    const result = await api.post<{ chargerSetup: ChargerSetup }>(
      '/charger-setups',
      { chargerSetup: newCharger }
    )

    return result.data.chargerSetup
  }

  public async delete(serialNumber: string) {
    await api.delete(`/charger-setups/${serialNumber}`)

    return null
  }

}

export const chargerAPI = new ChargerAPI()
